import React from 'react';
import {
	Card as MuiCard,
	CardContent,
	Typography as MuiTypography,
	Box,
	Grid
} from "@material-ui/core";
import styled from "styled-components";
import { spacing } from "@material-ui/system";
import useBusinessDivisions from "../../hooks/queries/useBusinessDivisions";

const Card = styled(MuiCard)(spacing);
const Typography = styled(MuiTypography)(spacing);

const DivisionCards = ({ accountId }) => {

	const { data: divisions } = useBusinessDivisions(accountId);

	const divisionName = d => {
		let name = d.divisionName;

		if (d.accountName)
			name += ` (${d.accountName})`

		return name;
	}; 

	if (!divisions || divisions.length === 0)
		return null;	

	return (
		<React.Fragment>
			{
				divisions.map(d => (
					<Grid container spacing={6}>
						<Grid key={d.id} item xs={12}>
							<Card mb={3} style={{ height: '100%' }}>
								<CardContent>
									<Typography variant="h6" mb={6}>{divisionName(d)}</Typography>
									<Box display="flex">
										<Box display="flex" flexDirection="column" gridGap="10px">
											<Box>
												<Typography variant="subtitle2">Risk Level</Typography>
												<Typography variant="caption">{d.risk || "Not set"}</Typography>
											</Box>
											<Box>
												<Typography variant="subtitle2">Key Account</Typography>
												<Typography variant="caption">{d.keyAccount ? "Yes" : "No"}</Typography>
											</Box>
										</Box>

									</Box>
								</CardContent>
							</Card>
						</Grid>
					</Grid>
				))}
		</React.Fragment>	
	)
}

export default DivisionCards;